// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2433ca56] .el-dialog__header{border:none;padding:16px 14px 0 21px}[data-v-2433ca56] .el-dialog__header .el-dialog__title{line-height:30px;font-size:14px;font-family:SourceHanSansCN-Bold,SourceHanSansCN;font-weight:700;color:#686868}[data-v-2433ca56] .el-dialog__body{padding:15px 30px 0 20px;border:none}[data-v-2433ca56] .el-input{width:80%;padding-left:10px}[data-v-2433ca56] .el-input .el-input__inner{height:28px}", ""]);
// Exports
module.exports = exports;
